import { Link } from "react-router-dom";
import {
  ABOUTUS_URL_LOCAL,
  CONTACTUS_URL_LOCAL,
  FAQ_URL_LOCAL,
  SEARCH_PRODUCT_URL_LOCAL,
} from "../../utility/BaseUrl";

const Footer = ({ data }) => {
  const { about_us, socials, categories } = data;
  function getRandomItems(arr, num) {
    const count = Math.min(arr.length, num);
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  }
  return (
    <footer className="footer-container mt-30">
      <div className="container">
        <div className="footer pt-20 pb-0 pt-md-50 pb-md-20">
          <div className="row">
            <div className="col-xs-6 col-md-3 col-lg-2">
              <div className="footer-title">دسته بندی محصولات</div>
              <div className="footer-menu mb-30">
                {categories.length > 0
                  ? getRandomItems(categories, 5).map((item, index) => {
                      const { slug, title, logo_title } = item;
                      const queryParams = new URLSearchParams({
                        category: title,
                      }).toString();
                      return (
                        <Link
                          title={logo_title}
                          key={`category_footer_${
                            (index + item.id) * Math.random(0, 1000)
                          }`}
                          to={SEARCH_PRODUCT_URL_LOCAL + `?${queryParams}`}
                          className="footer-menu-link"
                        >
                          {title}
                        </Link>
                      );
                    })
                  : null}
              </div>
            </div>
            <div className="col-xs-6 col-md-3 col-lg-2">
              <div className="footer-title">لینک های کاربردی</div>
              <div className="footer-menu mb-30">
                <Link to={ABOUTUS_URL_LOCAL} className="footer-menu-link">
                  درباره ما
                </Link>
                <Link to={CONTACTUS_URL_LOCAL} className="footer-menu-link">
                  ارتباط با ما
                </Link>
                <Link to={FAQ_URL_LOCAL} className="footer-menu-link">
                  پرسش های متداول
                </Link>
                <Link
                  to={SEARCH_PRODUCT_URL_LOCAL}
                  className="footer-menu-link"
                >
                  جستجوی پیشرفته
                </Link>
              </div>
            </div>
            <div className="col-sm-6 col-md-12 col-lg-4 col-xl-5 mb-30 order-md-last order-lg-0">
              <h3 className="footer-title"> فروشگاه اینترنتی صوت برتر </h3>
              {about_us.length > 0 ? (
                <>
                  <p
                    className="footer-contact-description m-0"
                    dangerouslySetInnerHTML={{
                      __html: about_us[0].about_me,
                    }}
                  />

                  <div className="footer-contact mt-20 pt-20">
                    <div className="row">
                      <div className="col-md-4 col-lg-12 col-xl-4">
                        <div className="footer-contact-item mb-30 d-flex align-items-center">
                          <img
                            src="/themes/custom-1a98/images/footer-phone.png"
                            alt={about_us[0].site_phone}
                            title={about_us[0].site_phone}
                            className="footer-contact-item-icon img-fluid ml-15"
                          />
                          {about_us[0].site_phone}
                        </div>
                      </div>
                      <div className="col-md-8 col-lg-12 col-xl-8">
                        <div className="footer-contact-item mb-30 d-flex align-items-center">
                          <img
                            src="/themes/custom-1a98/images/footer-map.png"
                            alt={about_us[0].site_address}
                            title={about_us[0].site_address}
                            className="footer-contact-item-icon img-fluid ml-15"
                          />
                          {about_us[0].site_address}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
            <div className="col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-30">
              <div className="footer-certificates d-flex align-items-center justify-content-center">
                <a
                  referrerpolicy="origin"
                  target="_blank"
                  href="https://trustseal.enamad.ir/?id=499110&amp;Code=BRnyBeTkP2Nm3qVei9amYlVAI9lU8vLu"
                >
                  <img
                    referrerpolicy="origin"
                    src="https://trustseal.enamad.ir/logo.aspx?id=499110&amp;Code=BRnyBeTkP2Nm3qVei9amYlVAI9lU8vLu"
                    alt=""
                    code="BRnyBeTkP2Nm3qVei9amYlVAI9lU8vLu"
                    style={{ cursor: "pointer" }}
                  />
                </a>
              </div>
              {/* <span className="btn d-block my-30 mx-30 footer-certificates-button">
                  ساعت کاری ۱۱ الی ۱۸
                </span> */}
            </div>
          </div>
        </div>
      </div>
      <div className="copyright py-20">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-6 text-center text-sm-right mb-15 mb-sm-0">
              <div className="copyright-text">
                تمامی حقوق این سایت متعلق به صوت برتر است.
              </div>
            </div>
            <div className="col-sm-6">
              {/*social*/}
              <div className="footer-social text-center text-sm-left">
                {socials.map((item) => {
                  const { title, url, is_active } = item;
                  if (is_active)
                    return (
                      <a
                        className="footer-social-link"
                        href={url}
                        title={title}
                      >
                        {title.includes("اینس") ? (
                          <span className="fa fa-instagram" />
                        ) : title.includes("تل") ? (
                          <span className="fa fa-send" />
                        ) : title.includes("توی") ? (
                          <span className="fa fa-twitter" />
                        ) : title.includes("وات") ? (
                          <span className="fa fa-whatsapp" />
                        ) : null}
                      </a>
                    );
                })}
              </div>
              {/*/social*/}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
